import React from "react";
import ReactMarkdown from "react-markdown";
import rehypeRaw from "rehype-raw";

import { useGetMarkdownQuery } from "./markdownApi";

function Markdown({
  source,
  spinner,
}: {
  source: string;
  spinner?: React.ReactNode;
}) {
  const { data: content, isLoading } = useGetMarkdownQuery(source);
  spinner =
    spinner == null ? (
      <div className="spinner-border" role="status">
        <span className="visually-hidden">Loading...</span>
      </div>
    ) : (
      spinner
    );
  if (isLoading) return <div className="text-center">{spinner}</div>;
  if (!content) return <div></div>;
  return (
    <ReactMarkdown rehypePlugins={[rehypeRaw]} className="markdown">
      {content}
    </ReactMarkdown>
  );
}

export default Markdown;
